module.exports = __webpack_public_path__ + "media/images/visa-90edd65980c1fc2b2aa00d93980cfc22.png";